import PBLogo from '@/assets/branding/pelicanbayou/pelicanbayoulogo.png';

const colors = {
  // Brand colors
  brand_primary: '#0E74B7',
  brand_primary_hover: '#0C639C', // −10 L, −8 S
  brand_primary_highlight: '#6AB7EB', // +23 L, +7 S
  brand_primary_mid: '#1B82C5', // +8 L,  +2 S
  brand_primary_dark: '#06355C', // −25 L, −3 S
  brand_secondary: '#0B5A8A', // hue +4°, −15 L, −13 S
  brand_accent_start: '#1E84C7',
  brand_accent_end: '#1CA39A',
  brand_accent_light_start: '#EAF5FC',
  brand_accent_light_end: '#DCF6F3',
  brand_complementary_accent: 'rgb(208,92,16)',
  brand_auth_gradient_mid: '#0B5A8A',
  brand_auth_gradient_end: '#06355C',
  brand_auth_warp_mid: '#1B82C5',
};

export default {
  name: 'Pelican Bayou',
  isSAML: true,
  allowPersonalCourses: false,
  logo: PBLogo,
  colors,
};
